import ReactToggle from "react-toggle";
import { FunctionComponent, memo } from "react";
import { Field, FieldProps } from "formik";

import { IProps } from "./toggle.types";
import "./toggle.scss";

/**
 * Toggle between two options.
 * @param props.onChange A function passed from a parent for additional actions during on change
 * @param props.leftLabel  The label for the left side of the toggle.
 * @param props.rightLabel The label for the right side of the toggle.
 * @param props.name       Field name.
 * @returns Toggle control.
 */
const Toggle: FunctionComponent<IProps> = ({ leftLabel, rightLabel, name, onChange }) => (
    <Field name={name}>
        {({ field, form }: FieldProps) => (
            <div className="toggle">
                <input
                    id={field.name}
                    name={field.name}
                    onChange={(changeEvent) => {
                        form.setFieldValue(field.name, changeEvent.target.checked);

                        if (typeof onChange === "function") {
                            onChange(changeEvent.target.checked);
                        }
                    }}
                    type="checkbox"
                />
                <label htmlFor={field.name}>
                    {leftLabel}
                    <ReactToggle
                        checked={field.value}
                        onChange={(changeEvent) => {
                            form.setFieldValue(field.name, changeEvent.target.checked);

                            if (typeof onChange === "function") {
                                onChange(changeEvent.target.checked);
                            }
                        }}
                    />
                    {rightLabel}
                </label>
            </div>
        )}
    </Field>
);

export default memo(Toggle);
